import { render, staticRenderFns } from "./ArticlesSoldOut.vue?vue&type=template&id=d7c4aa72&"
import script from "./ArticlesSoldOut.vue?vue&type=script&lang=js&"
export * from "./ArticlesSoldOut.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesSoldOut.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports